import { Container } from '@mui/material';
import { motion } from 'framer-motion';
import style from './HMSPage.module.css';

const upcoming = [
    { when: 'Tirsdag 12. mai', what: 'Vernerunde — Linje 2', who: 'Verneombud Linje 2 + HMS' },
    { when: 'Onsdag 20. mai', what: 'HMS-kvarter — alle skift', who: 'Driftsleder' },
    { when: 'Mandag 1. juni', what: 'Brannøvelse — hele anlegget', who: 'HMS-koordinator' },
];

type Hue = 'red' | 'gold' | 'cocoa';

interface Person {
    name: string;
    role: string;
    dept: string;
    phone: string;
    email: string;
    hue: Hue;
}

const people: Person[] = [
    { name: 'Kari Solberg',     role: 'HMS-koordinator',          dept: 'Brynild AS',     phone: '+47 469 12 345', email: 'kari.solberg@brynild.no',    hue: 'red' },
    { name: 'Magnus Olsen',     role: 'Verneombud',               dept: 'Linje 1',        phone: '+47 469 12 346', email: 'magnus.olsen@brynild.no',    hue: 'cocoa' },
    { name: 'Ingrid Berg',      role: 'Verneombud',               dept: 'Linje 2 og 3',   phone: '+47 469 12 347', email: 'ingrid.berg@brynild.no',     hue: 'gold' },
    { name: 'Tom Eriksen',      role: 'Verneombud',               dept: 'Pakkeri',        phone: '+47 469 12 348', email: 'tom.eriksen@brynild.no',     hue: 'red' },
    { name: 'Anne Lindgren',    role: 'Bedriftslege',             dept: 'Stamina HMS',    phone: '+47 22 36 70 00', email: 'anne.lindgren@stamina.no',  hue: 'cocoa' },
    { name: 'Lars Pedersen',    role: 'AMU-leder',                dept: 'Brynild AS',     phone: '+47 469 12 349', email: 'lars.pedersen@brynild.no',   hue: 'gold' },
];

function initials(name: string): string {
    return name
        .split(/\s+/)
        .map((n) => n[0]?.toUpperCase() ?? '')
        .slice(0, 2)
        .join('');
}

export default function HMSPage() {
    return (
        <Container maxWidth={false} className={style.page}>
            <motion.header
                className={style.pageHead}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
                <h1 className={style.pageTitle}>
                    <span className={style.pageTitleItalic}>Helse,</span> miljø og sikkerhet
                </h1>
                <div className={style.headRule} />
            </motion.header>

            <section className={style.section}>
                <header className={style.sectionHead}>
                    <span className={style.sectionKicker}>Kalender</span>
                    <h2 className={style.sectionTitle}>Kommende</h2>
                    <span className={style.sectionMeta}>3 oppførte aktiviteter</span>
                </header>

                <div className={style.upcoming}>
                    {upcoming.map((u, i) => (
                        <div key={i} className={style.upRow}>
                            <div className={style.upWhen}>{u.when}</div>
                            <div className={style.upWhat}>{u.what}</div>
                            <div className={style.upWho}>{u.who}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className={style.section}>
                <header className={style.sectionHead}>
                    <span className={style.sectionKicker}>Kontakt</span>
                    <h2 className={style.sectionTitle}>Verneombud og nødkontakter</h2>
                    <span className={style.sectionMeta}>Hele anlegget · Oppdatert mai 2026</span>
                </header>

                <div className={style.directory}>
                    {people.map((p, i) => (
                        <motion.article
                            key={p.email}
                            className={style.person}
                            initial={{ opacity: 0, y: 8 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.45, delay: 0.04 + i * 0.04 }}
                        >
                            <div className={`${style.avatar} ${style[`hue_${p.hue}`]}`} aria-hidden="true">
                                {initials(p.name)}
                            </div>
                            <div className={style.personBody}>
                                <div className={style.personRole}>{p.role}</div>
                                <h3 className={style.personName}>{p.name}</h3>
                                <div className={style.personDept}>{p.dept}</div>
                                <div className={style.personContact}>
                                    <a href={`tel:${p.phone.replace(/\s+/g, '')}`} className={style.personLink}>
                                        {p.phone}
                                    </a>
                                    <span className={style.personDot}>·</span>
                                    <a href={`mailto:${p.email}`} className={style.personLink}>
                                        {p.email}
                                    </a>
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </section>

        </Container>
    );
}
